<template>
  <div class="component-bridge-upload">
    <van-uploader
      ref="vanUploadFileRef"
      v-model="images"
      :max-count="maxCount"
      :max-size="isOverSize"
      :after-read="handleAfterRead"
      :readonly="isInApp"
      @click-upload="handleUploadByBridge"
      @oversize="handleOverSize"
      @delete="handleDeleteFile"
    >
      <slot />
    </van-uploader>
    <van-action-sheet v-model="showUploadSheet" :actions="actions" cancel-text="取消" @select="handleSelect" />
  </div>
</template>

<script>
import CompressImg from '@/utils/CompressImg'
import BlobUtil from '@/utils/CompressImg/blobutil'
import bridge, { isInApp, CAMERA, PHOTO, PDF } from '@/utils/bridge'
import { Toast } from 'vant'

export default {
  name: 'BridgeUploadSelect',
  props: {
    iType: {
      type: Number,
      default: 0
    },
    maxCount: {
      type: Number,
      default: 5
    },
    maxSize: {
      type: Number,
      default: 1000 * 1024
    },
    value: {
      type: Array,
      default: () => ([])
    },
    security: {
      type: Boolean,
      default: false
    },
    compress: {
      type: Object,
      default: null
    },
    api: {
      type: Function,
      default: () => {
        console.log('请传入接口调用api函数')
      }
    }
  },
  data() {
    return {
      showUploadSheet: false,
      actions: [
        { name: '拍照', value: CAMERA },
        { name: '从相册选择', value: PHOTO }
      ],
      images: [],
      isInApp,
      appVersion: '1.0'
    }
  },
  watch: {
    value() {
      this.images = (this.value || []).filter(item => !!item)
    }
  },
  mounted() {
    bridge.getAppVersion((version = '') => {
      this.appVersion = version
      console.log('version', version)
      if (version === '2.0') {
        this.actions = [
          { name: '拍照', value: CAMERA },
          { name: '从相册选择', value: PHOTO },
          { name: '上传PDF', value: PDF }
        ]
      }
    })
  },
  methods: {
    /**
     * 更新文件
     * @param file 需要更新的文件
     * @param index 需要更新的索引
     */
    updateFile(file, index = 0) {
      // 开始上传文件
      this.handleAfterRead(file)
    },

    /**
     * 如果通过bridge上传
     */
    handleUploadByBridge() {
      if (isInApp) {
        this.showUploadSheet = true
      }
    },

    /**
     * 删除文件
     * @param index 当前文件索引
     */
    handleDeleteFile(files, { index }) {
      // console.log('getPDF2')
      // 将文件id保存在照片中
      const newValue = [...this.value]
      // 从数组中删除此项
      newValue.splice(index, 1)
      // 开始双向绑定
      this.$emit('input', newValue)
      // 触发change方法
      this.$emit('change', newValue)
    },

    async handleAfterReadPDF(file) {
      // 等待上传的图片
      const uploadFile = file.file
      // 展示上传中状态
      file.status = 'uploading'
      file.message = '上传中...'
      try {
        // 记录文件上传的uuid
        file.uuid = await this.api(uploadFile)
        // 清空加载的提示信息
        file.status = ''
        file.message = ''
        // 文件集合
        const fileList = [...this.value, file]
        // 开始双向绑定
        this.$emit('input', fileList)
        // // 触发change方法
        this.$emit('change', fileList)
      } catch (error) {
        // 如果上传失败
        file.status = 'failed'
        file.message = '上传失败'
        console.error(error)
      }
    },
    /**
     * 读取文件后，开始上传文件
     * @param file 当前选中的文件
     */
    async handleAfterRead(file) {
      // 等待上传的图片
      let uploadFile = file.file
      // 如果当前需要压缩
      // console.log('1111111111111')
      if (this.compress) {
        try {
          uploadFile = await this.compressImage(file.file, this.compress)
        } catch (error) {
          console.log('压缩图片报错：', file.file)
          return
        }
      }
      // 展示上传中状态
      file.status = 'uploading'
      file.message = '上传中...'
      try {
        // 记录文件上传的uuid
        file.uuid = await this.api(uploadFile)
        // 清空加载的提示信息
        file.status = ''
        file.message = ''
        // 文件集合
        const fileList = [...this.value, file]
        // 开始双向绑定
        this.$emit('input', fileList)
        // // 触发change方法
        this.$emit('change', fileList)
      } catch (error) {
        // 如果上传失败
        file.status = 'failed'
        file.message = '上传失败'
        console.error(error)
      }
    },

    /**
     * 压缩图片
     * @param file 当前等待上传的文件
     * @param options 压缩选项
     */
    compressImage(file, options) {
      console.log('正在压缩图片。。。')
      return new Promise((resolve, reject) => {
        CompressImg(file, {
          size: 1000,
          quality: 80,
          ...options,
          cb: (dataURL) => {
            const abData = BlobUtil.base64ToArrayBuffer(dataURL)
            console.log('压缩后图片：', abData.length, ', 限制大小:' + this.maxSize)
            if (abData.length > this.maxSize) {
              this.handleOverSize()
              reject(false)
            } else {
              // 设置上传文件为压缩后的文件
              const compressedFile = BlobUtil.Blob([abData], { type: 'image/jpeg' })
              resolve(new File([compressedFile], file.name || '压缩后的文件.jpeg'))
            }
          }
        })
      })
    },

    /**
     * 选中方法
     * @param option 当前选中方法
     */
    handleSelect(option) {
      switch (option.value) {
        case CAMERA:
          bridge.getCamera(this.iType, (file) => {
            // 上传文件
            this.handleAfterRead(file)
          })
          break
        case PHOTO:
          bridge.getPhoto((file) => {
            // 上传文件
            this.handleAfterRead(file)
          })
          break
        case PDF:
          bridge.getPDF((file) => {
            // 上传文件
            this.handleAfterRead(file)
            // this.handleAfterReadPDF(file)
          })
          break
      }
      // 关闭弹框
      this.showUploadSheet = false
    },

    /**
     * 图片超过最大限制
     */
    handleOverSize() {
      if (this.compress) {
        return true
      }
      Toast('选择的图片超过最大限制，请重新选择')
    },

    /**
     * 是否超过尺寸限制
     */
    isOverSize(file) {
      // 如果当前需要压缩，则不判断
      if (this.compress) {
        return false
      }
      return file.size >= this.maxSize
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/FormRender/bridge-upload.vue